import React, { useState } from 'react'

import { InputText } from '../../../../components'

export default function BeepNfInput({ onEnter }) {
  const [beepNf, setBeepNf] = useState('')

  return (
    <InputText
      marginTop={10}
      label="Beep NF"
      value={beepNf}
      onChange={setBeepNf}
      onEnter={() => {
        onEnter(beepNf.trim())
        setBeepNf('')
      }}
    />
  )
}
